import { render, staticRenderFns } from "./AuthorityTree.vue?vue&type=template&id=5ea2be2d&scoped=true&"
import script from "./AuthorityTree.vue?vue&type=script&lang=js&"
export * from "./AuthorityTree.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityTree.vue?vue&type=style&index=0&id=5ea2be2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2be2d",
  null
  
)

export default component.exports